import { ChangeDetectorRef, Component, QueryList, ViewChildren } from '@angular/core';
import { ConcernCausePart } from '../models/concern-cause-part';
import { ClaimsAppConcernCausePartComponent } from '../claims-app-concern-cause-part/claims-app-concern-cause-part.component';
import { FormObjectListComponent } from '../../../shared/forms/form-object-list.component';

@Component({
  selector: 'claims-app-concern-cause-component-list',
  templateUrl: './claims-app-concern-cause-component-list.component.html',
})
export class ClaimsAppConcernCauseComponentListComponent extends FormObjectListComponent<ClaimsAppConcernCausePartComponent, ConcernCausePart> {
  @ViewChildren(ClaimsAppConcernCausePartComponent) override objectForms: QueryList<ClaimsAppConcernCausePartComponent>;
  
  constructor(override changeDetectorRef: ChangeDetectorRef) {
    super(changeDetectorRef);
    this.objectList = [ new ConcernCausePart(null, null, null) ];
  }

  public override add(): void {
    super.add(new ConcernCausePart(null, null, null));
  }

  public override remove(index: number): void {
    // Cannot remove first index.
    if (index > 0 && index < this.objectList.length) {
      super.remove(index);
    }
  }

  public override reset(): void {
    super.reset();
    this.objectList = [ new ConcernCausePart(null, null, null) ];
  }
}
